"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrandType_1 = require("../types/enums/BrandType");
var WhatsOnTVTabType_1 = require("../types/enums/WhatsOnTVTabType");
var graph_ql_1 = require("../types/graph-ql");
var utils_1 = require("./utils");
var dayjs_1 = __importDefault(require("dayjs"));
var isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
var ramda_1 = require("ramda");
var Entitlements_1 = require("./Entitlements");
dayjs_1.default.extend(isBetween_1.default);
exports.isShow = function (brand) {
    return (brand === null || brand === void 0 ? void 0 : brand.__typename) === BrandType_1.BrandType.Show;
};
exports.isPpv = function (brand) {
    return (brand === null || brand === void 0 ? void 0 : brand.__typename) === BrandType_1.BrandType.PayPerViewEvent;
};
exports.isPpvProgram = function (programme) { return (programme === null || programme === void 0 ? void 0 : programme.__typename) === BrandType_1.BrandType.PayPerViewEventProgram; };
exports.isContentPurchased = function (purchase) { return utils_1.isNotNilOrEmpty(purchase) && (purchase === null || purchase === void 0 ? void 0 : purchase.state) === graph_ql_1.CustomerPurchaseState.Active; };
/**
 * Checks if the provided brand is a TVOD (Transactional Video On Demand) movie.
 * It verifies that the any item in the `viewingMethods` array is a `TvodViewingMethod`.
 *
 * @param brand - The brand object, which can be a `Show`, `Movie`, or `PayPerViewEvent`.
 * @returns `true` if the brand is a TVOD movie, `false` otherwise.
 */
exports.isTvod = function (brand) {
    var _a;
    if (brand === null || brand === void 0 ? void 0 : brand.viewingMethods) {
        var tvod = (_a = brand.viewingMethods) === null || _a === void 0 ? void 0 : _a.some(function (viewingMethod) {
            var vodViewingMethod = viewingMethod;
            return (vodViewingMethod === null || vodViewingMethod === void 0 ? void 0 : vodViewingMethod.__typename) === 'TvodViewingMethod';
        });
        return !!tvod;
    }
    return false;
};
exports.isSport = function (brand) {
    return (brand === null || brand === void 0 ? void 0 : brand.__typename) === BrandType_1.BrandType.Show && brand.type === graph_ql_1.ShowType.Sport;
};
exports.findEpisode = function (seasons, episodeId) {
    var _a;
    if (!ramda_1.isNil(seasons)) {
        for (var i = 0; i < seasons.length; i += 1) {
            var season = seasons[i];
            var episode = (_a = season === null || season === void 0 ? void 0 : season.episodes) === null || _a === void 0 ? void 0 : _a.find(function (_episode) { return (_episode === null || _episode === void 0 ? void 0 : _episode.id) === episodeId; });
            if (episode) {
                return episode;
            }
        }
    }
};
exports.getProgrammeSynopsis = function (programme, brand) {
    var _a, _b, _c;
    // If passed in epg has synopsis already, no matter if it is Movie or ShowEpisode
    if (programme === null || programme === void 0 ? void 0 : programme.synopsis) {
        return programme.synopsis;
    }
    // if it is a Show
    if ((brand === null || brand === void 0 ? void 0 : brand.__typename) === BrandType_1.BrandType.Show) {
        var episode = exports.findEpisode(brand === null || brand === void 0 ? void 0 : brand.seasons, programme === null || programme === void 0 ? void 0 : programme.id);
        if (episode === null || episode === void 0 ? void 0 : episode.synopsis) {
            return episode === null || episode === void 0 ? void 0 : episode.synopsis;
        }
        // If no episodes, checking the EPG slots
        var epg = (_a = brand === null || brand === void 0 ? void 0 : brand.slots) === null || _a === void 0 ? void 0 : _a.find(function (slot) { var _a; return ((_a = slot.programme) === null || _a === void 0 ? void 0 : _a.id) === (programme === null || programme === void 0 ? void 0 : programme.id); });
        if ((_b = epg === null || epg === void 0 ? void 0 : epg.programme) === null || _b === void 0 ? void 0 : _b.synopsis) {
            return (_c = epg === null || epg === void 0 ? void 0 : epg.programme) === null || _c === void 0 ? void 0 : _c.synopsis;
        }
    }
    return (brand === null || brand === void 0 ? void 0 : brand.synopsis) || '';
};
exports.getCharactersText = function (characters) {
    if (utils_1.isNilOrEmpty(characters)) {
        return '';
    }
    return ramda_1.pipe(ramda_1.pluck('actorName'), ramda_1.join(', '))(characters);
};
exports.getSeasonTitle = function (seasonsNumber) {
    if (utils_1.isNilOrEmpty(seasonsNumber) || seasonsNumber === 0) {
        return null;
    }
    return ramda_1.gt(seasonsNumber, 1) ? seasonsNumber + " Seasons" : seasonsNumber + " Season";
};
exports.getDefaultWhatsOnTVTab = function (brand) {
    if (brand.__typename === 'Show') {
        if (brand.type === graph_ql_1.ShowType.Sport) {
            // For Sport, the Upcoming rail will be the default state if there is content
            return !ramda_1.isNil(brand.slots) && !ramda_1.isEmpty(brand.slots)
                ? WhatsOnTVTabType_1.WhatsOnTVTabType.Upcoming
                : WhatsOnTVTabType_1.WhatsOnTVTabType.Recent;
        }
        return !ramda_1.isNil(brand.episodes) && !ramda_1.isEmpty(brand.episodes)
            ? WhatsOnTVTabType_1.WhatsOnTVTabType.Recent
            : WhatsOnTVTabType_1.WhatsOnTVTabType.Upcoming;
    }
    return WhatsOnTVTabType_1.WhatsOnTVTabType.Upcoming;
};
exports.getFirstAvailableSlot = function (brand) {
    if (exports.isPpv(brand)) {
        // if it is ppv brand, it will look for the next available liveSlots first then
        // if not find look for previous live slot,
        // if not find look for either running or future slot
        // if still not find, return null
        var now_1 = dayjs_1.default();
        var availableSlot = brand === null || brand === void 0 ? void 0 : brand.slots.find(function (slot) { return now_1.isBefore(dayjs_1.default(slot.end)); });
        if (utils_1.isNotNilOrEmpty(availableSlot)) {
            var liveSlots = brand === null || brand === void 0 ? void 0 : brand.slots.filter(function (slot) { return slot.live; });
            if (utils_1.isNotNilOrEmpty(liveSlots)) {
                var nextLiveSlot = liveSlots.find(function (slot) { return now_1.isBefore(dayjs_1.default(slot.end)); });
                if (utils_1.isNotNilOrEmpty(nextLiveSlot)) {
                    return nextLiveSlot;
                }
                var previousLiveSlot = ramda_1.findLast(function (slot) { return now_1.isAfter(dayjs_1.default(slot.end)); }, liveSlots);
                if (utils_1.isNotNilOrEmpty(previousLiveSlot)) {
                    return previousLiveSlot;
                }
            }
            return availableSlot;
        }
    }
    else if (utils_1.isNotNilOrEmpty(brand === null || brand === void 0 ? void 0 : brand.slots)) {
        return brand.slots.reduce(function (a, b) {
            return a.start <= b.start ? a : b;
        });
    }
    return undefined;
};
exports.getSeasonEpisodeNumber = function (seasonNumber, episodeNumber) {
    if (!ramda_1.isNil(seasonNumber) && !ramda_1.isNil(episodeNumber)) {
        return "S" + String(seasonNumber).padStart(1, '0') + " E" + String(episodeNumber).padStart(1, '0');
    }
    return '';
};
exports.getVodTitle = function (brand, episode, ignoreSeasonAndEpisode) {
    var _a;
    var brandTitle = brand === null || brand === void 0 ? void 0 : brand.title;
    if (exports.isShow(brand)) {
        if (exports.isSport(brand)) {
            return episode === null || episode === void 0 ? void 0 : episode.title;
        }
        var seasonEpisodeNumber = exports.getSeasonEpisodeNumber((_a = episode === null || episode === void 0 ? void 0 : episode.season) === null || _a === void 0 ? void 0 : _a.number, episode === null || episode === void 0 ? void 0 : episode.number);
        return ramda_1.isEmpty(seasonEpisodeNumber) || ignoreSeasonAndEpisode
            ? brandTitle
            : brandTitle + " " + seasonEpisodeNumber;
    }
    return brandTitle;
};
exports.hasPlayableVod = function (brand) {
    var _a;
    if (brand.__typename === BrandType_1.BrandType.Movie) {
        return utils_1.isNotNilOrEmpty(brand.asset);
    }
    if (brand.__typename === BrandType_1.BrandType.Show) {
        // TODO This sports-speicific rule should be set from BE, but we could not apply the change on API, as the native old version handle it in different way.
        // We could revisit this once BE updates.
        // Sports show would always ignore the vod.
        if (exports.isSport(brand)) {
            return false;
        }
        return utils_1.isNotNilOrEmpty((_a = brand.defaultEpisode) === null || _a === void 0 ? void 0 : _a.asset);
    }
    // TODO We do not have the concept of defaultEventProgram for PPV (similar to defaultEpisode for show).
    // This will have to be implemented in backend first then needs to add checks here
    return false;
};
var getInitialPlaybackState = function () {
    return {
        isPlayable: false,
        isRecordable: false,
        isPurchaseRequired: false,
        hasVod: false,
        hasSubscriptions: false,
        videoContent: null,
    };
};
var getShowPlayBackState = function (brand) {
    var playbackState = getInitialPlaybackState();
    var firstAvailableSlot = exports.getFirstAvailableSlot(brand);
    playbackState.hasSubscriptions =
        utils_1.isNotNilOrEmpty(brand === null || brand === void 0 ? void 0 : brand.defaultEpisode) && Entitlements_1.isVodEntitled(brand === null || brand === void 0 ? void 0 : brand.defaultEpisode);
    if (exports.hasPlayableVod(brand)) {
        playbackState.hasVod = true;
        playbackState.isPlayable = true;
        playbackState.videoContent = brand.defaultEpisode;
    }
    else if (utils_1.isNotNilOrEmpty(firstAvailableSlot)) {
        playbackState.isPlayable = true;
        playbackState.videoContent = firstAvailableSlot;
        playbackState.isRecordable = true;
    }
    return playbackState;
};
var isTvodViewingMethod = function (viewingMethod) {
    var _a;
    return ((_a = viewingMethod) === null || _a === void 0 ? void 0 : _a.__typename) === 'TvodViewingMethod';
};
var isPPVViewingMethod = function (viewingMethod) {
    var _a;
    return ((_a = viewingMethod) === null || _a === void 0 ? void 0 : _a.__typename) === 'PayPerViewViewingMethod';
};
exports.getTvodViewingMethodFromBrand = function (brand) {
    var _a, _b;
    if (brand === null || brand === void 0 ? void 0 : brand.viewingMethods) {
        return (_b = (_a = brand.viewingMethods) === null || _a === void 0 ? void 0 : _a.filter(isTvodViewingMethod)) === null || _b === void 0 ? void 0 : _b[0];
    }
    return undefined;
};
exports.getPPVViewingMethodFromBrand = function (brand) {
    var _a, _b;
    if (((brand === null || brand === void 0 ? void 0 : brand.__typename) === 'PayPerViewEvent' || (brand === null || brand === void 0 ? void 0 : brand.__typename) === 'PayPerViewEventProgram') &&
        brand.viewingMethods) {
        return (_b = (_a = brand.viewingMethods) === null || _a === void 0 ? void 0 : _a.filter(isPPVViewingMethod)) === null || _b === void 0 ? void 0 : _b[0];
    }
    return undefined;
};
exports.getSubscriptions = function (channel) {
    if (channel && Array.isArray(channel.viewingMethods)) {
        return channel.viewingMethods.reduce(function (acc, viewingMethod) {
            var _a;
            var VMethod = viewingMethod;
            if ((VMethod === null || VMethod === void 0 ? void 0 : VMethod.__typename) === 'LinearViewingMethod' ||
                (VMethod === null || VMethod === void 0 ? void 0 : VMethod.__typename) === 'VodViewingMethod') {
                var subs = ((_a = VMethod.packages) === null || _a === void 0 ? void 0 : _a.map(function (pkg) {
                    var _a;
                    return ({
                        id: pkg === null || pkg === void 0 ? void 0 : pkg.id,
                        title: pkg === null || pkg === void 0 ? void 0 : pkg.title,
                        offerId: (_a = pkg === null || pkg === void 0 ? void 0 : pkg.offer) === null || _a === void 0 ? void 0 : _a.id,
                    });
                })) || [];
                return acc.concat(subs);
            }
            return acc;
        }, []);
    }
    return undefined;
};
var getMoviePlaybackState = function (brand) {
    var _a, _b, _c;
    var playbackState = getInitialPlaybackState();
    var firstAvailableSlot = exports.getFirstAvailableSlot(brand);
    var hasSubscription = Entitlements_1.isVodEntitled(brand);
    var purchase = (_c = (_b = (_a = exports.getTvodViewingMethodFromBrand(brand)) === null || _a === void 0 ? void 0 : _a.tvodOffer) === null || _b === void 0 ? void 0 : _b.purchases) === null || _c === void 0 ? void 0 : _c[0];
    playbackState.isPurchaseRequired =
        exports.isTvod(brand) && !hasSubscription && !exports.isContentPurchased(purchase);
    playbackState.hasSubscriptions = hasSubscription;
    if (exports.hasPlayableVod(brand)) {
        playbackState.hasVod = true;
        playbackState.isPlayable = true;
        playbackState.videoContent = brand.asset;
    }
    else if (utils_1.isNotNilOrEmpty(firstAvailableSlot)) {
        playbackState.isPlayable = true;
        playbackState.videoContent = firstAvailableSlot;
        playbackState.isRecordable = true;
    }
    return playbackState;
};
var getPpvPlaybackState = function (brand) {
    var _a, _b;
    var playbackState = getInitialPlaybackState();
    var ppvViewingMethod = exports.getPPVViewingMethodFromBrand(brand);
    var purchase = (_b = (_a = ppvViewingMethod === null || ppvViewingMethod === void 0 ? void 0 : ppvViewingMethod.payPerViewOffer) === null || _a === void 0 ? void 0 : _a.purchases) === null || _b === void 0 ? void 0 : _b[0];
    var firstAvailableSlot = exports.getFirstAvailableSlot(brand);
    playbackState.hasSubscriptions = utils_1.isNotNilOrEmpty(ppvViewingMethod);
    playbackState.isPurchaseRequired = !exports.isContentPurchased(purchase);
    // TODO We do not have the concept of defaultEventProgram for PPV (similar to defaultEpisode for show).
    // This will have to be implemented in backend first then needs to add checks here
    if (exports.hasPlayableVod(brand)) {
        playbackState.hasVod = true;
        playbackState.isPlayable = true;
        // TODO playbackState.videoContent = brand.defaultEventProgram;
    }
    else if (utils_1.isNotNilOrEmpty(firstAvailableSlot) && !utils_1.isNotNilOrEmpty(brand.eventPrograms)) {
        playbackState.isPlayable = true;
        playbackState.videoContent = firstAvailableSlot;
        playbackState.isRecordable = true;
    }
    return playbackState;
};
exports.getContentPlaybackState = function (brand) {
    switch (brand === null || brand === void 0 ? void 0 : brand.__typename) {
        case BrandType_1.BrandType.Show:
            return getShowPlayBackState(brand);
        case BrandType_1.BrandType.Movie:
            return getMoviePlaybackState(brand);
        case BrandType_1.BrandType.PayPerViewEvent:
            return getPpvPlaybackState(brand);
        default:
            return getInitialPlaybackState();
    }
};
//# sourceMappingURL=Title.js.map